// Projectile sprite sizing — pure helper (CF3). The drawn sprite tracks the projectile's COLLISION
// radius so a shot reads where it actually hits, instead of a fixed oversized sprite floating over a
// pin-sized hitbox. ~ the hit diameter, with a small readability floor. Render-only — no sim impact.

export function projectileSpriteSize(radius: number): number {
  return Math.max(0.35, radius * 2.2)
}
